/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient, useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { ActivityItemWorker } from "../work-items/@types";

const fetch = async (params: any): Promise<PaginatedResult<ActivityItemWorker>> => {
    const stats = await apiInputService.get("/frontend/dashboard/activityItem/department/role", {
        params: {
            ...params
        }
    })
    const { data } = stats;

    return data as PaginatedResult<ActivityItemWorker>;
}


export const useDashboardAtvsRequiringActionByDepartmentRole = (
    params: any,
    options?: any
) => {

    const { subscription } = useSubscription();

    return useQuery(
        ["dashboard", "atvs", "department", subscription?.subscriptionId, params], 
        () => fetch(params), {
        ...options,
        enabled: !!subscription?.subscriptionId,
        keepPreviousData: true
    });
}


export const prefetchData = (queryClient: QueryClient, params: any, subscription: string) => {
    queryClient.prefetchQuery(
        ["dashboard", "atvs", "department", subscription, params], 
        () => fetch(params),
        {
            staleTime: 1000 * 60 * 5,
        }
    )
}